import type { FaireProductEntity } from "../../entity_types/product";

export const p_3fnduwwp45: FaireProductEntity = {
  token: "p_3fnduwwp45",
  type: "product",
  name: "Pre-Mixed Case of Popcorn - 100 Count - 3 Cup Bags",
  brandName: "Deanan Gourmet Popcorn",
  imageUrl:
    "https://cdn.faire.com/fastly/7ccf7a031d3d0a11cb9bcfa369a95d9c8de12cbbc26f615f9df5459320a3ebab.png",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ef1037ccbe98fe31a432bb43c47e4b47bd3b56811b910c0499a6d429616900b2.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
